import React, { PropTypes } from 'react'
import cx from 'classnames'
import { Link } from 'react-router'
import { Button } from '../buttons'

export const Collection = ({constraints, actionType, actionLink, children, secondaryActionType, secondaryActionCall}) => {
  let action = (!!actionType && !!actionLink)
  let secondaryAction = (!!secondaryActionType && !!secondaryActionCall)
  let actionElement = null
  let secondaryActionElement = null

  if (constraints && constraints.hasOwnProperty('width')) {
    constraints = {
      minWidth: constraints.width,
      maxWidth: constraints.width
    }
  }

  if (action) {
    actionElement = <Link to={actionLink} className={`action-button ${actionType}`} />
  }

  if (secondaryAction) {
    secondaryActionElement = <Button onClick={secondaryActionCall} className={`action-button ${secondaryActionType}`} />
  }

  const classNames = cx('collection-container', { 'no-action': !action && !secondaryAction })

  return (
    <div>
      <section style={constraints} className={classNames}>
        <div className="action-container">
          {actionElement}
          {secondaryActionElement}
        </div>
        <section className='collection'>
          {children}
        </section>
      </section>
    </div>
  )
}

Collection.propTypes = {
  actionType: PropTypes.string,
  actionLink: PropTypes.string,
  constraints: PropTypes.object
}

export const Group = ({title, children}) => {
  let titleElement = null

  if (title) {
    titleElement = <h2 className='collection-container-title'>{title}</h2>
  }
  return (
    <section className='collection-group'>
      {titleElement}
      {children}
    </section>
  )
}

Group.propTypes = {
  title: PropTypes.string
}

export const LoadMore = ({hasNextPage, onLoadNextPage}) => {
  const classNames = cx('card', 'load-more', { hidden: !hasNextPage })

  return (
    <div className={classNames} onClick={onLoadNextPage}>
      Load more...
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/details/collection.js